import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

export const echo = new Echo({
  broadcaster: "reverb",
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT ?? 443,
  wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
  forceTLS: import.meta.env.VITE_REVERB_SCHEME === "https",
  enabledTransports: ["ws", "wss"],
  disableStats: true,
});

// Connection state management
echo.connector.pusher.connection.bind("connected", () => {
  console.log("✅ WebSocket connected");
  try {
    window.dispatchEvent(new Event("app:ws-connected"));
  } catch (e) {}
});

echo.connector.pusher.connection.bind("disconnected", () => {
  console.log("⚠️ WebSocket disconnected");
  try {
    window.dispatchEvent(new Event("app:ws-disconnected"));
  } catch (e) {}
});

echo.connector.pusher.connection.bind("error", (error) => {
  console.error("❌ WebSocket error:", error);
  try {
    window.dispatchEvent(new CustomEvent("app:ws-error", { detail: error }));
  } catch (e) {}
});

export default echo;
